import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PaginatedResponse, BaseEntity } from '@services/core/AbstractService';

interface UseTableQueryProps<T extends BaseEntity> {
  queryKey: (string | number | undefined | URLSearchParams)[];
  fetchFn: () => Promise<PaginatedResponse<T>>;
  options?: Omit<
    UseQueryOptions<PaginatedResponse<T>>,
    'queryKey' | 'queryFn'
  >;
}

/**
 * Custom hook for table data fetching with React Query
 * @param queryKey - Unique query identifier
 * @param fetchFn - Function to fetch data
 * @param options - Additional React Query options
 */
export function useTableQuery<T extends BaseEntity>({
  queryKey,
  fetchFn,
  options,
}: UseTableQueryProps<T>) {
  return useQuery({
    queryKey,
    queryFn: fetchFn,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    ...options,
  });
}
